<template>
  <div>
    <!--  -->
    <B1 />

    <B2 />

    <B3 />
  </div>
</template>

<script>
import B1 from "./components/b1.vue";
import B2 from "./components/b2.vue";
import B3 from "./components/b3.vue";

export default {
  components: {
    B1,
    B2,
    B3,
  },
};
</script>

<style>
</style>